// export const Regex_Accept_Alpha_Dot_Comma_Space = /^[a-zA-Z,. ]*$/;
// export const Regex_Accept_Alpha = /^[a-zA-Z,. ]*$/;
export const Regex_Accept_Alpha_Dot_Comma_Space = /.*/;
export const Regex_Accept_Alpha = /.*/;
export const Regex_Accept_Everything = /.*/;
export const Regex_Accept_Number = /^\d+(\.\d+)?$/;
// export const Regex_Accept_Number = /^\d+$/;

export const Regex_Youtube = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;